import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDigitalRetailingCheckbox } from '../../components/search-filters-digital-retailing-checkbox/digital-retailing-checkbox'
import { useATTrackInteraction } from '@at/consumer-web-snowplow'

export const DigitalRetailingCheckbox = () => {
    const fireTrackInteraction = useATTrackInteraction()

    return withFacetContext(
        FacetName.with_digital_retailing,
        withFilterContext(FilterName.with_digital_retailing, SearchFiltersDigitalRetailingCheckbox, {
            title: `Reserve online with the option to finance or part exchange`,
            hideOnDisabled: false,
            hideCount: true,
            onValueChanged: (val) => {
                fireTrackInteraction({
                    trackingLabel: `filter reserve with autotrader - ${val.length > 0 ? 'on' : 'off'}`,
                })
            },
        })
    )({})
}
